import { AnticipatedMonthlyActivityNA } from 'commons/types/DTO/commons'

import { AnticipatedMonthlyActivityNAFormValue } from '../../../../types/forms'

export const mapAnticipatedMonthlyActivityNAForm = (
  formValues: AnticipatedMonthlyActivityNAFormValue
): AnticipatedMonthlyActivityNA => ({
  ...formValues
})
